import Axios from "axios";
import React, { Component } from "react";
import { Bar } from 'react-chartjs-2';  
import AppConfig from "../../../../../../config/AppConfig";
class BarChartMengisiLengkap extends Component {
    constructor(props) {
      super(props)
      this.state = {
          jenis_pendidikan :[],
          label :[],
          mengisi :[],
          tidakmengisi:[],
      }
    }
    
    options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    userCallback: function(label, index, labels) {
                        // when the floored value is the same as the value we have a whole number
                        if (Math.floor(label) === label) {
                            return label;
                        }
   
                    },
                }
            }],
        },
    }
    async componentDidMount(){
        this.setState({display: false});
        let id_institusi = localStorage.getItem("id_sp_temp");
        let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
        let id_sp = sessiondata.i_idunit;
        if(id_institusi !== ""){
            id_sp = id_institusi;
        }if(id_institusi === null){
            id_sp = sessiondata.i_idunit;
        }
        let session = "";
        let userdata = JSON.parse(localStorage.getItem("userdata"));
        if(userdata){
            session = 
            "?id_pengguna="+userdata.id_pengguna+
            "&id_unit="+ id_sp +
            "&id_role="+sessiondata.i_idrole;
        }
        let i = 0;
        let labels = [];
        let mengisi = [];
        let tidakmengisi = [];
          Axios.get(
            AppConfig.DetailDashboard+"lengkapbybentukpt"+session
          ).then(res => {
            this.setState({
                jenis_pendidikan: res.data.result.data,
            });
            for (var key in this.state.jenis_pendidikan) {
                labels[i] = key;
                mengisi[i] = this.state.jenis_pendidikan[key].lengkap;
                tidakmengisi[i] = this.state.jenis_pendidikan[key].belum_lengkap;
                i = i + 1;
            }
            
            this.setState({
                label: labels,
                mengisi: mengisi,
                tidakmengisi: tidakmengisi,
            });
          }) 
          .catch(err => {
            alert("not found")
          }) 
    }
    render(){
      let datas = {
        labels: this.state.label,
        datasets: [
        {
            label: 'Lengkap',
            fill: false,
            lineTension: 0.1,
            backgroundColor: '#79B4B7',
            borderColor: '#79B4B7',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#79B4B7',
            pointBackgroundColor: '#79B4B7',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#79B4B7',
            pointHoverBorderColor: '#79B4B7',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: this.state.mengisi
        },
        {
            label: 'Tidak Lengkap',
            fill: false,
            lineTension: 0.1,
            backgroundColor: '#FFB344',
            borderColor: '#FFB344',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: '#FFB344',
            pointBackgroundColor: '#FFB344',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: '#FFB344',
            pointHoverBorderColor: '#FFB344',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: this.state.tidakmengisi
        },
        ]
      };
        return(
            <>
                <Bar data={datas} options={this.options}/>
            </>
        )
    }
}
export default BarChartMengisiLengkap;